/**
 * Lists all possible usPower values.
 */
export default [
  { key: 'bottom', value: 'Bottom' },
  { key: 'left', value: 'Side left' },
  { key: 'right', value: 'Side right' },
]
